module.exports = __webpack_public_path__ + "img/netvs_logo.cdebe0f3.png";